<div class="imgIn">
  @if (label && label.trim()) {
    <span [class]="merge('imgIn__label', labelClass)" aria-hidden="true">{{ label }}</span>
  }

  <!-- Visually hidden but focusable: keyboard users tab here and press Space.
       While loading it stays focusable (so focus is not lost) but does not
       open the picker. -->
  <input
    #fileInput
    type="file"
    name="imageInput"
    class="imgIn__file bk-sr-only"
    [id]="inputId"
    [accept]="accept"
    [attr.aria-label]="fileInputLabel"
    [attr.aria-describedby]="errorMessage ? hintId + ' ' + errorId : hintId"
    [attr.aria-disabled]="isLoading ? 'true' : null"
    (click)="onFileInputClick($event)"
    (change)="onFileSelected($event)"
  />

  <div class="imgIn__row">
    <!-- The whole tile opens the file picker. Hidden from screen readers:
         the file input above carries the name. -->
    <label
      [for]="inputId"
      [class]="merge('imgIn__frame', roundedClass, sizeClass, imageContainerClass)"
      [class.has-image]="!!previewUrl"
      [class.is-busy]="isLoading"
      aria-hidden="true"
    >
      @if (previewUrl) {
        <img [src]="previewUrl" alt="" [class]="merge('imgIn__img', imageClass)" />
      } @else if (!isLoading) {
        <span class="bk-sym imgIn__placeholder" aria-hidden="true">add_photo_alternate</span>
      }

      @if (isLoading) {
        <span class="imgIn__busy">
          <app-loading-spinner [size]="1.25" className="text-white" />
        </span>
      }
    </label>

    <div class="imgIn__side">
      @if (confirmingRemove && previewUrl && !isLoading) {
        <!-- Remove deletes the saved image at once, so it asks first. -->
        <div class="imgIn__actions imgIn__confirm" role="group" [attr.aria-labelledby]="inputId + '-ask'" (keydown.escape)="keepImage()">
          <span class="imgIn__ask" [id]="inputId + '-ask'">Remove {{ subject }}?</span>
          <button type="button" class="imgIn__btn" data-tone="danger" (click)="clearSelection()">
            <span class="bk-sym" aria-hidden="true">delete</span>
            Remove
          </button>
          <button #keepBtn type="button" class="imgIn__btn imgIn__btn--quiet" (click)="keepImage()">Keep</button>
        </div>
      } @else {
        <div class="imgIn__actions">
          <label
            [for]="inputId"
            class="imgIn__btn"
            [class.is-disabled]="isLoading"
            aria-hidden="true"
          >
            <span class="bk-sym" aria-hidden="true">{{ previewUrl ? 'sync' : 'upload' }}</span>
            {{ previewUrl ? 'Change' : 'Upload' }}
          </label>
          @if (previewUrl && !isLoading) {
            <button #removeBtn type="button" class="imgIn__btn imgIn__btn--quiet" (click)="askRemove()">
              <span class="bk-sym" aria-hidden="true">delete</span>
              Remove
            </button>
          }
        </div>
      }
      <p class="imgIn__hint" [id]="hintId">
        Image up to {{ sourceLimitInMB }} MB.@if (enableCropper) { You can crop it before saving.}
      </p>
    </div>
  </div>

  @if (errorMessage) {
    <p class="imgIn__error" [id]="errorId" role="alert">
      <span class="bk-sym" aria-hidden="true">error</span>
      <span>{{ errorMessage }}</span>
    </p>
  }

  <!-- Image Cropper Modal -->
  @if (showCropperModal) {
    <image-cropper-modal
      [imageUrl]="tempImageUrl"
      (imageCropped)="onImageCropped($event)"
      (cancelled)="onCropperCancelled()"
      (failed)="onCropperFailed()"
    />
  }
</div>
